export const saveUtmParams = (utmPrams) => {
    if (!(utmPrams && Object.keys(utmPrams).length > 0)) {
        return;
    }

    localStorage.setItem('how2spanish-utms', JSON.stringify(utmPrams));
}



export const getUtmParams = () => {
    return JSON.parse(localStorage.getItem('how2spanish-utms', '{}')) || {};
}
